import frappe from './frappe';

export const getInvoices = async (customerId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Invoice?filters=[["customer","=","${customerId}"],["docstatus","=","1"]]&fields=["name","grand_total","status","posting_date"]&limit=200`
    );

    const invoicesWithProducts = await Promise.all(
      data.data.map(async (inv) => {
        const products = await getInvoicesProducts(inv.name);
        return {
          invoiceId: inv.name,
          invoiceName: inv.name,
          products,
        };
      })
    );

    return invoicesWithProducts;
  } catch (error) {
    console.error('Error al obtener invoices y productos:', error);
    return [];
  }
};

const getInvoicesProducts = async (invoiceId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Invoice%20Item?filters=[["parent","=","${invoiceId}"]]&fields=["item_name","qty","amount"]&limit=200`
    );
    return data.data.map(item => ({
      label: item.item_name,
      total_ttc: item.amount,
      qty: item.qty,
    }));
  } catch (error) {
    console.error(`Error al obtener productos de invoice ${invoiceId}:`, error);
    return [];
  }
};

export const getInvoiceById = async (invoiceId) => {
  try {
    const { data } = await frappe.get(`/api/resource/Sales%20Invoice/${invoiceId}`);
    return data.data;
  } catch (error) {
    console.error('Error al obtener la factura:', error.message);
    return null;
  }
};

export const isOrderBilled = async (orderId) => {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order/${orderId}?fields=["status","per_billed"]`
    );
    const { per_billed } = data.data;
    return per_billed >= 100;
  } catch (error) {
    console.error('Error checking if order is billed:', error.message);
    return false;
  }
};
